import { ConsentValidationErrors } from '@/pages/avatar/api';
import { CreateAvatarStore } from '@/pages/avatar/CreatePage/CreateAvatarStore';
import { PremiumPlusCreateAvatarStore } from '@/pages/avatar/PremiumPlusCreatePage/CreateAvatarStore';

export enum RequestStatus {
    IDLE = 'idle',
    LOADING = 'loading',
    SUCCESS = 'success',
    ERROR = 'error',
}

export enum AvatarCreateTab {
    CHOOSE_AVATAR,
    INSTRUCTIONS,
    FOOTAGE,
    CONSENT,
    WAIT_FOR_UPLOADS,
}

export enum FootageMethod {
    Footage = 'footage',
    Webcam = 'webcam',
}
export interface FootageRequirements {
    maxFileSizeInMB: number;
    minFileDurationInSeconds: number;
    maxFileDurationInSeconds: number;
    uploadFootageSubtext: string;
    minResolution?: number;
}

export interface RecordingTimes {
    minRecordingTime: number;
    recordingTime: number;
}

export type UploadFootageHandler = (
    file: File | null,
    setStatus: (status: RequestStatus) => void,
    setUrl: (url: string) => void,
    abortSignal: AbortSignal
) => Promise<void>;

export enum AvatarType {
    Express = 'express',
    PremiumPlus = 'premium_plus',
}

export enum MixpanelGroupEventDelete {
    Avatar = 'avatar-delete',
    Train = 'train-delete',
}

export type CreateAvatarStoreUnion = CreateAvatarStore | PremiumPlusCreateAvatarStore;

export type Consent = {
    id: string;
    created_at: string;
    modified_at: string;
    created_by: string;
    thumbnail_url: string;
    video_url: string;
    name: string;
    status: string;
    error?: {
        description: string;
        kind: ConsentValidationErrors;
    };
};

export type GetConsentsResponse = {
    consents: Consent[];
};

export interface GreenscreenParams {
    chroma_key: string;
    similarity: number;
    blend: number;
}
